import { useEffect, useState } from 'react';
import MobileTopSectionWithFilter from '@/TRC/components/TopSections/mobileTopSectionWithFilter';
import TopSectionWithFilter from '@/TRC/components/TopSections/topSectionWithFilter';
import { useLocation } from 'react-router-dom';
import api from '@/data/api';
import Toast from '@/utils/toastManager';
import TRC_PAGE_CATEGORIES from '@/TRC/constants/trcCategories';
import ResourcesGrid from '@/TRC/pages/Resources/components/grid';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import { isStudioUser } from '@/utils/isStudioUser';

const TRCViewAll = () => {
	const { search, pathname } = useLocation();
	const query = new URLSearchParams(search);
	const tagData = query.get('tag');
	const userData = useAtomValue(userInfoAtom);
	const isStudioHub = isStudioUser(userData);

	const [contents, setContents] = useState();
	const [selectedTags, setSelectedTags] = useState([]);

	useEffect(() => {
		if (tagData) {
			setSelectedTags([tagData]);
		}
	}, [tagData]);

	useEffect(() => {
		async function fetchContents() {
			try {
				const [trcResponse, lessonPlanResponse] = await Promise.all([
					api.fetchContent({ tags: selectedTags.length > 0 ? selectedTags.join(',') : undefined }),
					isStudioHub ? api.getLessonPlans() : Promise.resolve({ data: [] })
				]);

				const trcContents = trcResponse?.data || [];
				const progressiveLessonPlans = (lessonPlanResponse?.data || []).map(plan => ({
					...plan,
					fileType: 'pdf',
					categoryDetails: [
						{ _id: 'studio-lesson-plan', name: 'Progressive Lesson Plan', color: '#008bc3' },
						...(plan.categoriesDetails || [])
					]
				}));

				setContents([...trcContents, ...progressiveLessonPlans]);
			} catch (err) {
				Toast.error(err.message || 'Something went wrong');
			}
		}
		fetchContents();
	}, [selectedTags, isStudioHub]);

	return (
		<div className="d-flex flex-column gap-2">
			<MobileTopSectionWithFilter
				contents={contents}
				setContents={setContents}
				category={TRC_PAGE_CATEGORIES.VIEW_ALL}
				containsPdf
			/>
			<TopSectionWithFilter setContents={setContents} contents={contents} category={TRC_PAGE_CATEGORIES.VIEW_ALL} containsPdf />
			<ResourcesGrid contents={contents} />
		</div>
	);
};

export default TRCViewAll;
